import api from './api';

const CATALOG_BASE_URL = process.env.REACT_APP_CATALOG_API_URL;

// 1. Obtener Tipos de Eventos
export const getEventTypes = async () => {
  const response = await api.get('/api/catalog/event-types', {
    baseURL: CATALOG_BASE_URL
  });
  return response.data.data;
};

// 2. Obtener Eventos/Artistas
export const getEventsByType = async (eventType) => {
  const response = await api.get('/api/events', {
    baseURL: CATALOG_BASE_URL,
    params: {
      event_type: eventType,
      active: true
    }
  });
  return response.data.data;
};

// 3. Obtener Fechas
export const getEventDates = async (eventId) => {
  const response = await api.get(`/api/events/${eventId}/dates`, {
    baseURL: CATALOG_BASE_URL
  });
  return response.data.data;
};

// 4. Obtener Esquema de Carga (ESTA ES LA QUE FALTABA)
export const getUploadSchema = async (area) => {
  try {
    // También le agregamos /api por si acaso tu backend lo requiere así
    const response = await api.get(`/api/areas/${area}/upload-schema`, {
      baseURL: CATALOG_BASE_URL
    });
    return response.data;
  } catch (error) {
    // Si falla o no existe, retornamos null para que el front use defaults
    console.warn("No se pudo cargar esquema de validación para el área.");
    return null;
  }
};
